module.exports = __webpack_public_path__ + "static/media/icon_logout.f27b43a4.svg";